import {
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  TransactionalFootnoteModel,
  TransactionalMutationInput,
} from './model';

export function useUpdateTransactionalFootnote(
  options?: UseMutationOptions<
    ApiResult<TransactionalFootnoteModel>,
    ApiError,
    TransactionalMutationInput
  >,
): UseMutationResult<
  ApiResult<TransactionalFootnoteModel>,
  ApiError,
  TransactionalMutationInput
> {
  return useMutation<
    ApiResult<TransactionalFootnoteModel>,
    ApiError,
    TransactionalMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `${body.type}/${body.id}/transactional-footnote`,
      method: 'PUT',
      classType: TransactionalFootnoteModel,
      body: body.body,
    });
  }, options);
}
